import React, { PureComponent } from 'react';
import T from 'prop-types';
import noop from 'lodash/fp/noop';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@nintex-ux/react-core/dist/Modal';
import { Button } from '@nintex-ux/react-core/dist/Button';

export default class Dialog extends PureComponent {
  static displayName = 'Dialog';

  static propTypes = {
    children: T.node.isRequired,
    header: T.string.isRequired,
    noLabel: T.string,
    open: T.bool,
    yesLabel: T.string,
    onAction: T.func.isRequired,
    onClose: T.func,
  };

  static defaultProps = {
    noLabel: '',
    onClose: noop,
    open: false,
    yesLabel: 'Yes',
  };

  render() {
    const {
      header,
      children,
      noLabel,
      yesLabel,
      onAction,
      onClose,
      open,
    } = this.props;
    return open ? (
      <Modal
        onClose={onClose}
        overlayClassName=""
        size="small"
        open={open}
        type="info"
      >
        <ModalHeader onClose={onClose} closeButton>
          {header}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          {noLabel && (
            <Button type="secondary" onClick={() => onAction(false)}>
              {noLabel}
            </Button>
          )}
          <Button type="primary" onClick={() => onAction(true)}>
            {yesLabel}
          </Button>
        </ModalFooter>
      </Modal>
    ) : null;
  }
}
